import makeStyles from '@mui/styles/makeStyles';
import { getBrandCustom } from "../../../utils/getCustomColor";

const styles = makeStyles(() => ({
  closeIcon: {
    color: `${getBrandCustom("primaryColor", "#308CDB")} !important`,
  },
  chip: {
    borderRadius: "4px",
    backgroundColor: "#EDF5FB",
    color: getBrandCustom("primaryColor", "#308CDB"),
    fontFamily: "Manrope",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
}));

export default styles;
